import { classifyConfirmError, isRetryableConfirmError } from '@/lib/papertrade/onboarding'

export type SignPhase =
  | { kind: 'idle' }
  | { kind: 'signing' }
  | { kind: 'confirming'; signature: string; preparedAt: number }
  // retry keeps the signature; restart/fatal do not.
  | { kind: 'retry'; signature: string; preparedAt: number; message: string }
  | { kind: 'restart'; message: string }
  | { kind: 'fatal'; message: string }
  // The key is registered but the caller's follow-up (onDone) failed; only that is retried.
  | { kind: 'finish-failed'; message: string }

/** Phase after `confirm` rejects with `message`. */
export function phaseAfterConfirmError(
  message: string,
  signature: string,
  preparedAt: number,
  error?: unknown
): SignPhase {
  const cls = isRetryableConfirmError(error) ? 'retry' : classifyConfirmError(message)
  if (cls === 'retry') return { kind: 'retry', signature, preparedAt, message }
  if (cls === 'restart') return { kind: 'restart', message }
  return { kind: 'fatal', message }
}

/** Phase after the caller's `onDone` rejects: registration succeeded, so never re-sign. */
export function phaseAfterDoneError(message: string): SignPhase {
  return { kind: 'finish-failed', message }
}

/** Whether an async result belongs to the attempt still on screen; `null` = unmounted. */
export function isCurrentAttempt(started: string, current: string | null): boolean {
  return current !== null && started === current
}
